export default __webpack_public_path__ + "static/blexiaLogo-d912a9371b00e1b89aecd4792ea84bfc.svg";